<section class="position-relative">
    <div *ngIf="activarLoader">
        <mat-progress-bar mode="indeterminate" ></mat-progress-bar>
    </div>
    <div class="modal-header">
        <span mat-dialog-close class="cursor-pointer btn-close-modal">
          <mat-icon>close</mat-icon>
        </span>
        <div class="modal-title">
            <div class="bg-blue">
                <div class="flex-x-btw w-97">
                    <h2 mat-dialog-title color="primary">
                     <span class="header-1">{{tituloModal}}</span>
                    </h2>
                    <div>

                        <!-- <button  *ngIf="true" type="button"   class="bg-primary mr-1"  mat-button   (click)="adicionarNovoArtigo()">
                            <span >Novo {{opcoes[data.tipoDocumento.codNatureza]}}</span>
                        </button> -->
                        <button  type="button"   class="bg-primary mr-1"  mat-button   (click)="getArtigosFacturacao()">
                            <span >Actualizar</span>
                        </button>
                    </div>

                </div>
            </div>
        </div>

        <div class="w-100 bg-light border-b position-relative">
            <div class="flex w-100 flex-even txt-bold pb-05 border-b text-primary-1 ">
                <div class="grow-1 w-5" *ngIf="false"></div>
                <div class="grow-1 w-12 text-center"><div class="text-flex">C&oacute;digo</div></div>
                <div class="grow-1 w-11 text-center"><div class="text-flex">Tipo</div></div>
                <div class="grow-1 w-20 text-center"><div class="text-flex">Designação</div></div>
                <div class="grow-4 w-5"><div class="text-flex">UN</div></div>
                <div class="grow-1 w-15 text-center"><div class="text-flex-1">Preço {{empresa.codMoeda1}}</div></div>
                <div class="grow-1 w-5"><div class="text-flex">Iva (%)</div></div>

                <div class="grow-1 w-5 text-center"><div class="text-flex">Gere <br> Stocks</div></div>
                <div class="grow-1 w-12 text-center"><div class="text-flex">Estado</div></div>
                <div class="grow-1 w-8 text-center"><div class="text-flex">Sujeito a <br> Retenções </div></div>
            </div>
            <div class="flex w-100 flex-even pt-03 pb-03 border-b ">
                <div class="flex w-100 flex-even bg-light-1">
                    <div class="grow-1 w-5" *ngIf="false"><mat-checkbox color="primary"></mat-checkbox></div>
                    <div class="grow-1 w-12 text-center">
                        <input  type="search"  class="tb-filtro-input border rounded"  #codigo (input)="filtrarValores($event, 1)" placeholder="filtrar código"/>
                    </div>
                    <div class="grow-1 w-11 text-center"> <input  type="search" class="tb-filtro-input border rounded" (input)="filtrarValores($event, 2)" placeholder="filtrar tipo"/></div>
                    <div class="grow-1 w-20 text-left"> <input (input)="filtrarValores($event, 3)" type="search" class="tb-filtro-input border rounded"  placeholder="filtrar designação"/> </div>
                    <div class="grow-4 w-5"> <span class="invisible">.</span></div>
                    <div class="grow-1 w-15 text-center"> <span class="invisible">.</span> </div>
                    <div class="grow-1 w-5"> <span class="invisible">.</span> </div>
                    <div class="grow-1 w-5 text-center"> 
                        <!-- <input (input)="filtrarValores($event, 4)" type="search" class="tb-filtro-input border rounded" placeholder="filtrar estado"/>  -->
                    </div>
                    <div class="grow-1 w-12 text-center"> <input (input)="filtrarValores($event, 4)" type="search" class="tb-filtro-input border rounded" placeholder="filtrar estado"/> </div>
                    <div class="grow-1 w-8 text-center"> <span class="invisible">.</span> </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-body p-0">
        <section style="height: 65vh; overflow-y: auto; display: block; width: 100%;" >
            <div>
                <div>
                    <div class="flex w-100 flex-even border-b" *ngFor="let item of listaArtigos; let i = index" >
                        <div class="grow-1 w-5" *ngIf="false"><mat-checkbox color="primary"  (change)="adicionarItem(item, i)"></mat-checkbox></div>
                        <div class="grow-1 w-12 cursor-pointer hvr-accent text-left"  (click)="selecCodigo(item)"> {{ data.tipoArtigos === 1 ? item.codArtigo : item?.codArtigo }} </div>
                        <div class="grow-1 w-11 text-left"> {{item?.tipo}}</div>
                        <div class="grow-1 w-20 text-left">{{ data.tipoArtigos === 1 ? item.descricao : item?.artigo }}</div>
                        <div class="grow-4 w-5 text-left" >  {{ item?.codUnidade }} </div>

                        <div class="grow-1 w-15 text-left"> <div class="w-100 w-8 text-center">{{ item?.preco1 | currency: " " }}</div> </div>
                        <div class="grow-1 w-5"> <div class="w-100 text-center">{{ item?.taxaIva | currency: ' ' }}</div> </div>
                        <div class="grow-1 w-5 text-left" >
                            <div class="text-left">
                                
                                <span class="p-03 " [ngClass]="{rounded: (item?.geridoPorStocks === true || 
                                    item?.geridoPorStocks === false),
                                    'bg-light-gray': (item?.geridoPorStocks === true || 
                                    item?.geridoPorStocks === false)
                                }">{{ item?.geridoPorStocks === true? 'Sim' :
                                     item?.geridoPorStocks === false ? 'Não':'' }}</span>
                            </div> 
                        </div>
                        <div class="grow-1 w-12 text-left"> {{item?.estado}} </div>
                        <div class="grow-1 w-8 text-left">
                            <div class="text-left">
                                <span class="p-03" [ngClass]="{rounded: (item?.sujeitoARetencao === true || 
                                    item?.sujeitoARetencao === false),
                                    'bg-light-gray': (item?.sujeitoARetencao === true || 
                                    item?.sujeitoARetencao === false)}">{{ item?.sujeitoARetencao === true? 'Sim' : 
                                    item?.sujeitoARetencao === false ? 'Não' : '' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <mat-divider></mat-divider>
        <div class="pb-16 pt-1 px-1 ">
            <div class="flex flex-x-btw">
                <button mat-dialog-close class="bg-secondary mr-1" mat-button>
                    Cancelar
                </button>
                <span fxFlex></span>
                <button  type="button"   class="bg-primary mr-0"  mat-button   (click)="confirmar(todosArtigos)">
                    Confirmar
                </button>
            </div>
        </div>
    </div>
</section>
